import React from 'react'
import { GrTopCorner, GrBottomCorner } from 'react-icons/gr'

const LottiePlaceholder = (props) => {
    return (
        <div className={`placeholder-content-view mx-5 mx-auto ${props.className}`} style={{ width: props.width ? props.width : 800 }} >
            <GrTopCorner size={40} strokeOpacity="0.3" style={{ position: 'relative', top: 10, left: -20, marginBottom: -15, }} />
            <p style={{ textAlign: 'justify', width: props.width ? props.width : 800, color: '#2f2f2f', marginBottom: 0, fontSize: 16 }}>
                {props.text}
            </p>
            <GrBottomCorner size={40} strokeOpacity="0.3" style={{ position: 'relative', bottom: 28, right: props.width ? -props.width + 20 : -775, }} />
        </div>
    )
}

export default LottiePlaceholder